<template>
    <section id="location" class="scroll-mt-24">
        <h3 class="text-lg font-semibold mb-4">{{ $t('Location') }}</h3>
        <iframe class="w-full h-64 rounded-lg" :src="`https://maps.google.com/maps?q=${item.property.latitude},${item.property.longitude}&z=15&output=embed`" style="border: 0" allowfullscreen loading="lazy"></iframe>
        <p class="text-gray-600 text-xs mt-2">{{ $t('The map shows the approximate location of the accommodation.') }}</p>
    </section>
</template>

<script setup>
const props = defineProps({
    item: {
        type: Object,
        required: true
    }
})
</script>
